<template>
  <v-dialog max-width="600" v-model="downloaddialog" class="image-popup">
    <template #activator="{ on }">
      <v-btn :disabled="itemsCount <= 0" right color="primary" v-on="on">
        <span class="d-none d-md-flex">{{ buttonText }}</span>
        <v-icon right>mdi-download</v-icon>
      </v-btn>
    </template>
    <v-btn
      color="primary"
      @click="downloaddialog = false"
      icon
      class="popup-close"
    >
      <v-icon>mdi-close-circle-outline</v-icon>
    </v-btn>

    <v-card>
      <div class="diaog-inner pa-10 grey lighten-5">
        <v-card-title> Download photos </v-card-title>

        <v-card-text>
          <v-form>
            <v-select
              :items="items"
              v-model="namingConvention"
              item-text="name"
              item-value="id"
              label="Select a naming convention"
              filled
              dense
              solo
              flat
            >
            </v-select>

            <v-select
              :items="csvOptions"
              v-model="csvChoice"
              item-text="name"
              item-value="id"
              label="CSV options"
              filled
              dense
              solo
              flat
            >
            </v-select>

            <v-checkbox
              hide-details
              v-model="watermark"
              label="Watermark images"
              class="mb-4"
            ></v-checkbox>
            <v-btn color="primary" class="mt-2" @click="downloadSelected()">
              Save
            </v-btn>
          </v-form>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { DownloadService } from "@/common/api.service";
import toast from "@/services/toast";

export default {
  name: "DownloadDialog",
  props: {
    buttonText: "",
    collectionId: null,
  },
  data: () => ({
    csvOnly: false,
    csvChoice: "csvIncluded",
    downloaddialog: false,
    csvOptions: [
      { id: "csvIncluded", name: "CSV and image files" },
      { id: "csvOnly", name: "CSV file only (Images excluded)" },
      { id: "csvExclude", name: "Image files only (CSV excluded)" },
    ],
    watermark: false,
    namingConvention: "id",
    items: [
      { id: "id", name: "Photo {$id}.ext" },
      { id: "chain", name: "Photo {$id} - {$chain}.ext" },
      { id: "region", name: "Photo {$id} - {$chain} - {$region}.ext" },
      {
        id: "store",
        name: "Photo {$id} - {$chain} - {$region} - {$store}.ext",
      },
      {
        id: "sub_call",
        name: "Photo {$id} - {$chain} - {$region} - {$store} - {$sub_call}.ext",
      },
    ],
  }),
  computed: {
    itemsCount() {
      if (this.collectionId) return 1;
      return this.selectedImagesIds.length;
    },
    ...mapGetters([
      "activeExpClient",
      "selectedImagesIds",
      "imageSearchResult",
      "currentUser",
    ]),
  },
  mounted() {
    // Add naming convention if client manger
    if (this.currentUser.roles.includes("client-manager") === true) {
      this.items.push({
        id: "call",
        name:
          "Photo {$id} - {$call_id} - {$merchandiser_id} - {$merchandiser_name}.ext",
      });
      // this.items.push({id:'signature', name:"Photo {$id} - {$merchandiser_id} - {$merchandiser_name} - {$call_id} - {$sub_call} - {$date}.ext"})
      this.items.push({
        id: "signature",
        name:
          "Photo {$id} - {$merchandiser_id} - {$merchandiser_name} - {$date} - {$question_wording}.ext",
      });
      this.items.push({
        id: "chain-store",
        name:
          "Photo {$id} - {$chain} - {$store_code} - {$store} - {$call_id} - {$question}.ext",
      });
      // this.items.push({id:'question', name:"Photo {$id} - {$question}.ext"})
    }
  },
  methods: {
    downloadSelected() {
      const params = {};
      if (this.selectedImagesIds.length > 0) {
        params.photo_ids = this.selectedImagesIds;
        params.imageCount = this.selectedImagesIds.length;
      } else if (this.collectionId) {
        params.collection_id = this.collectionId;
        params.imageCount = this.imageSearchResult.total;
      }
      params.name = this.activeExpClient.name;
      params.naming_structure = this.namingConvention;
      params.client_id = (this.$route.params.clientId) ? this.$route.params.clientId : this.activeExpClient.id;
      params.csv_choice = this.csvChoice
      params.csv_only = this.csvOnly;
      params.watermark = this.watermark;
      DownloadService.zip(params);
      this.downloaddialog = false;
    },
  },
};
</script>
